import type { CMSAssetAuditAction } from '../constants';
import type { CMSAssetType } from '../types';
import { useMutation } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';

export type CreateAssetAuditDataProps = {
  topLevelContentId: string;
  assetId: string;
  assetType: CMSAssetType;
  actionType: CMSAssetAuditAction;
};

export function createAssetAuditData(data: CreateAssetAuditDataProps): Promise<boolean> {
  return FetchPromise.post('cms/assets/audit', data);
}

export function useCreateAssetAuditData() {
  return useMutation(createAssetAuditData);
}
